module.exports = __webpack_public_path__ + "img/first-day-2.bfc76a7e.png";